import React from "react";
import { useParams } from "react-router";
import { Box } from "@chakra-ui/react";
import { TabsComponent } from "../../components/TabsComponent";
import { ContentPage } from "../ContentPage";
import { PeoplePage } from "../PeoplePage";

export const ClassesPage = ({ user, userRole }) => {
  const { id } = useParams();
  const tabList = [
    {
      id: 1,
      name: "content",
    },
    {
      id: 2,
      name: "reports",
    },
    {
      id: 3,
      name: "people",
    },
  ];
  const tabPanels = [
    {
      panel: <ContentPage user={user} userRole={userRole} classId={id} />,
    },
    {
      panel: <p>In Progress</p>,
    },
    {
      panel: <PeoplePage user={user} userRole={userRole} classId={id} />,
    },
  ];

  return (
    <Box
      style={{
        maxWidth: "100%",
        margin: "0 auto",
      }}
    >
      <TabsComponent
        tabList={tabList}
        tabPanels={tabPanels}
        justifyContent="center"
      />
    </Box>
  );
};
